declare global {
  interface Window {
    Intercom: any;
  }
}

export function openHome() {
  if (typeof window.Intercom === 'function') {
    window.Intercom('showSpace', 'home');
  }
}

export function openHelpCenter() {
  if (typeof window.Intercom === 'function') {
    window.Intercom('showSpace', 'help');
  }
}

export function openMessages() {
  if (typeof window.Intercom === 'function') {
    window.Intercom('showSpace', 'messages');
  }
}

export function showArticle(articleId: string) {
  if (typeof window.Intercom === 'function') {
    window.Intercom('showArticle', parseInt(articleId, 10));
  }
}

export function shutdownIntercom() {
  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
  }
}

export function bootIntercom(appId: string) {
  if (typeof window.Intercom === 'function') {
    window.Intercom('boot', {
      app_id: appId,
      custom_launcher_selector: '.launch-intercom',
      hide_default_launcher: true,
    });
  }
}
